import React from 'react';
import moment from 'moment';
import {
    Card, Button, CardTitle,
    Col, Alert, Row,
    Form, FormGroup, Label, FormText
} from 'reactstrap';
import { Field, reduxForm, reset, formValueSelector } from 'redux-form';
import { InputBs, InputDayPicker, AlertFormLengkap, AlertFormBelumLengkap } from '../';
import { ibu, kabkot, kecamatan } from '../../../../actions';
import { connect } from 'react-redux';
import { cookies, cookieName } from '../../../../global';

let FormIbu = (props) => {
    const { handleSubmit,
        pristine, submitting, dispatch,
        ref_provinsi_ibu, ref_kabkot_ibu, ref_kecamatan_ibu,
        status_ibu } = props;

    const handleProvinsi = (e) => {
        const val = e.target.value;
        dispatch(kabkot.fetchForIbu(val));
        dispatch({ type: 'FETCH_KECAMATAN_IBU_FULFILLED', payload: [] });
    };

    const handleKabkot = (e) => {
        const val = e.target.value;
        dispatch(kecamatan.fetchForIbu(val));
    };

    return (
        <Form onSubmit={handleSubmit}>
            <FormGroup row className="mb-4">
                <Label for="nama_ibu" col="12" xl="3" className="mb-2 mb-xl-0">Nama Lengkap</Label>
                <Col col="12" xl="9">
                    <Field name="nama_ibu" component={InputBs} type="text" placeholder="Nama Lengkap" />
                </Col>
            </FormGroup>

            <FormGroup row className="mb-4">
                <Label for="status_ibu" col="12" xl="3" className="mb-2 mb-xl-0">Status Ibu</Label>
                <Col col="12" xl="9">
                    <Row>
                        <Col col="6" sm="4" xl="3">
                            <FormGroup check>
                                <Label check>
                                    <Field
                                        name="status_ibu"
                                        component={InputBs}
                                        type="radio"
                                        value="hidup"
                                    />{' '}Hidup</Label>
                            </FormGroup>
                        </Col>
                        <Col col="6" sm="4" xl="3">
                            <FormGroup check>
                                <Label check>
                                    <Field
                                        name="status_ibu"
                                        component={InputBs}
                                        type="radio"
                                        value="wafat"
                                    />{' '}Wafat</Label>
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
            </FormGroup>

            <FormGroup row className="mb-4">
                <Label col="12" xl="3" className="mb-2 mb-xl-0">Tempat &amp; Tanggal Lahir</Label>
                <Col col="12" xl="9">
                    <Row>
                        <Col col="12" md="6" className="mb-2 mb-md-0">
                            <Field name="tempat_lahir_ibu" component={InputBs} type="text" placeholder="Tempat Lahir" />
                        </Col>
                        <Col col="12" md="6">
                            <Field name="tanggal_lahir_ibu" component={InputDayPicker} startYear={1950} placeholder="Tanggal Lahir" />
                        </Col>
                    </Row>
                </Col>
            </FormGroup>

            {/* <FormGroup row className="mb-4">
                <Label for="pekerjaan_ibu" col="12" xl="3" className="mb-2 mb-xl-0">Pekerjaan</Label>
                <Col col="12" xl="9">
                    <Field name="pekerjaan_ibu" component={InputBs} type="text" placeholder="Pekerjaan Ibu" />
                </Col>
            </FormGroup> */}

            {status_ibu === 'hidup' && (
                <div className="animate-fade-in">
                    <FormGroup row className="mb-4">
                        <Label for="alamat_ibu" col="12" xl="3" className="mb-2 mb-xl-0">Alamat Lengkap</Label>
                        <Col col="12" xl="9">
                            <Field name="alamat_ibu" component={InputBs} type="textarea" rows="3" placeholder="Alamat Lengkap" />
                        </Col>
                    </FormGroup>
                    <FormGroup row className="mb-4">
                        <Label for="provinsi_ibu" col="12" xl="3" className="mb-2 mb-xl-0">Provinsi</Label>
                        <Col col="12" xl="9">
                            <Field name="provinsi_ibu" component={InputBs} type="select"
                                onChange={handleProvinsi}>
                                <option value="">-- Pilih Provinsi --</option>
                                {Array.isArray(ref_provinsi_ibu) ? ref_provinsi_ibu.map((data, key) =>
                                    <option value={data.provinsi_id} key={key}>{data.provinsi_nama}</option>
                                ) : ''}
                            </Field>
                        </Col>
                    </FormGroup>
                    <FormGroup row className="mb-4">
                        <Label for="kabkot_ibu" col="12" xl="3" className="mb-2 mb-xl-0">Kab/Kota</Label>
                        <Col col="12" xl="9">
                            <Field name="kabkot_ibu" component={InputBs} type="select"
                                onChange={handleKabkot}>
                                <option value="">-- Pilih Kabupaten/Kota --</option>
                                {Array.isArray(ref_kabkot_ibu) ? ref_kabkot_ibu.map((data, key) =>
                                    <option value={data.kab_id} key={key}>{data.kab_nama}</option>
                                ) : ''}
                            </Field>
                        </Col>
                    </FormGroup>
                    <FormGroup row className="mb-4">
                        <Label for="kecamatan_ibu" col="12" xl="3" className="mb-2 mb-xl-0">Kecamatan</Label>
                        <Col col="12" xl="9">
                            <Field name="kecamatan_ibu" component={InputBs} type="select" >
                                <option value="">-- Pilih Kecamatan --</option>
                                {Array.isArray(ref_kecamatan_ibu) ? ref_kecamatan_ibu.map((data, key) =>
                                    <option value={data.kecam_id} key={key}>{data.kecam_nama}</option>
                                ) : ''}
                            </Field>
                        </Col>
                    </FormGroup>
                    <FormGroup row className="mb-4">
                        <Label for="telepon_ibu" col="12" xl="3" className="mb-2 mb-xl-0">Nomor Telepon</Label>
                        <Col col="12" xl="9">
                            <Field name="telepon_ibu" component={InputBs} type="text" placeholder="Nomor Telepon" pattern="[0-9]{0,13}" title="Hanya isi dengan angka 0-9. Maksimal 13 digit." />
                            <FormText color="muted">
                                Hanya isi dengan angka. Maksimal 13 digit.
                            </FormText>
                        </Col>
                    </FormGroup>
                </div>
            )}

            <FormGroup row className="mt-5 border-top pt-4">
                <Col md={{ size: 8 }} xs="12" className="mb-3 mb-md-0">
                    {!props.allow ? <AlertFormBelumLengkap /> : <AlertFormLengkap />}
                </Col>
                <Col md={{ size: 4 }} xs="12">
                    <Button type="submit" className="modern-btn-primary w-100 py-3 font-weight-bold" disabled={submitting}>
                        <i className="fa fa-save mr-2"></i> {submitting ? ' Menyimpan...' : ' Simpan Data'}
                    </Button>
                </Col>
            </FormGroup>
        </Form>
    );
};

class DataIbu extends React.Component {
    UNSAFE_componentWillMount() {
        this.props.dispatch(ibu.fetchAllData(cookies.get(cookieName)));
    }

    submitForm = (values) => {
        const formData = new FormData();

        // Logika: Jika wafat, hapus data alamat/telepon agar tidak konflik di database backend
        const submissionValues = values.status_ibu === 'wafat'
            ? { ...values, alamat_ibu: '-', telepon_ibu: '-', provinsi_ibu: '', kabkot_ibu: '', kecamatan_ibu: '' }
            : values;

        Object.keys(submissionValues).forEach(key => {
            let val = submissionValues[key];
            if (val === null || val === undefined) return;
            if (val instanceof Date || moment.isMoment(val)) {
                val = moment(val).format('YYYY-MM-DD');
            } else if (val && typeof val === 'object' && !Array.isArray(val)) {
                if (val.input || val.meta || (val.name && val.onChange)) {
                    val = '';
                }
            }
            formData.append(key, val || '');
        });

        this.props.dispatch(ibu.updateData(cookies.get(cookieName), formData))
            .then(() => {
                this.props.updateVerifikasi();
                // Opsional: fetch ulang untuk memastikan data store paling baru
                this.props.dispatch(ibu.fetchAllData(cookies.get(cookieName)));
            })
            .catch((err) => {
                console.error("Gagal menyimpan data ibu", err);
            });
    }

    render() {
        return (
            <Card body>
                <CardTitle tag="h5">Data Ibu</CardTitle>
                <Alert color="warning">
                    <i className="fa fa-info-circle"></i> Seluruh kolom pada Data Ibu <b>Wajib Diisi</b>
                </Alert>
                <FormIbu
                    onSubmit={this.submitForm}
                    initialValues={this.props.ibu_data}
                    allow={this.props.allow}
                    dispatch={this.props.dispatch}
                />
            </Card>
        );
    }
}

FormIbu = reduxForm({
    form: 'DataIbu',
    enableReinitialize: true,
    // Menghindari field yang di-unmount terhapus dari state sebelum submit
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(FormIbu);

const selector = formValueSelector('DataIbu');

FormIbu = connect((store) => {
    const status_ibu = selector(store, 'status_ibu');
    return {
        status_ibu,
        ref_provinsi_ibu: store.provinsi.provinsi,
        ref_kabkot_ibu: store.kabkot.kabkot_ibu,
        ref_kecamatan_ibu: store.kecamatan.kecamatan_ibu,
    };
})(FormIbu);

export default connect(
    (store) => ({
        ibu_data: store.ibu.ibu,
    })
)(DataIbu);